<div mat-dialog-title *ngIf="data=='price changes alert'">Price changes since last login
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form (submit)="checkProductBeforeAddToCart()" novalidate>
  
 <div *ngIf="data=='price changes alert'" style="font-size: 20px;"> 
  <br>
  The below item(s) had a price change since your last login on {{lastLogin}}
</div>

  <div class="row"  *ngIf="data!='price changes alert'" >
      <span id="lbl-sort-by" class="headerColor heading">Sort</span>
  </div>
  <div class="row"  >
    <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12" *ngIf="data!='price changes alert'" >
      <select class="no-mobile" placeholder="Sort By" name='sortBy' id="sort-by" [(ngModel)]='productHistoryFilterOptions.sortBy'
        (change)="onProductHistorySorts()">
        <option value="brandName" id="brand-name">
          Brand Name
        </option>
        <option value="description" id="description">
          Product Description
        </option>
        <option *ngIf="websiteName=='Parmed'" value="manufacturer" id="manufacturer">
          Manufacturer
        </option>
        <option value="labelSize" id="label-size">
          Size
        </option>
        <option value="invoiceDate" id="invoice-date">
          Last Purchase Date
        </option>
        <option value="invoicePrice" id="invoice-price">
          Last Purchase Price
        </option>
      </select>
      <select class="no-mobile" placeholder="Direction" name='direction' id="direction" [(ngModel)]='productHistoryFilterOptions.direction'
        (change)="onProductHistorySorts()">
        <option value="asc" id="asc ">
          A-Z
        </option>
        <option value="des" id="des">
          Z-A
        </option>
      </select>
      <span class="case-alert" *ngIf="caseAlertObject.showCaseAlert" [ngStyle]="{'color': isCaseMisMatch   ? 'red': 'black'}">{{caseAlertObject.caseAlert}}</span>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 padding-left-15" *ngIf="data!='price changes alert'" >
      <mat-radio-group *ngIf="invoiceFilter[0]==true" name="accountsIncluded"  class="Invoice-radio-group" id="pay-invoice-include" (change)="onInvFilterSelect($event)"  color="primary">
        <mat-radio-button value="Major" id="Major-acnt">Major&nbsp;</mat-radio-button>
        <mat-radio-button value="Rugby" id="Rugby-acnt">Rugby&nbsp;</mat-radio-button>
        <mat-radio-button checked value="allInv" id="all-acnts">All</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" style="float: right;">
      <div class="add-cart-button top">
        <button type="submit" mat-raised-button id="btn-add-to-cart" color="accent" [disabled]="!isAddToCartDisable()">Add To Cart</button>
      </div>
    </div>
   
  </div>
  <div [ngClass]="{'mat-table-size': websiteName === 'Major'}">
    <mat-table [dataSource]="purchaseHistoryDataSource" >
    <ng-container matColumnDef="itemId">
      <mat-header-cell *matHeaderCellDef><span id="lbl-item">Item #</span></mat-header-cell>
      <mat-cell *matCellDef="let product; let i = index" id="item-{{i+1}}">
        {{product.itemId}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ndc">
      <mat-header-cell *matHeaderCellDef><span id="lbl-ndc"[ngClass]="{'mat-column-mat-coloumn-ndc': websiteName === 'Major'}">NDC</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="ndc-{{i+1}}">
        {{product.ndc}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="brandName">
      <mat-header-cell *matHeaderCellDef><span id="lbl-brand">Brand Name</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="brand-{{i+1}}">
        {{product.brandName}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="productDescription">
      <mat-header-cell *matHeaderCellDef [ngClass]="{'mat-column-productDescription': websiteName === 'Major'}"><span id="lbl-description">Product Description</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="description-{{i+1}}">
        <span class="product-alert cold-alert" id="cold-alert-{{i+1}}" *ngIf="coldAlert(product)"></span>
        <span class="product-alert hazard-alert" id="hazard-alert-{{i+1}}" *ngIf="hazardAlert(product)"></span>
        {{product.description}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="manufacturer">
      <mat-header-cell *matHeaderCellDef><span id="lbl-manufacturer">Manufacturer</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="manufacturer-{{i+1}}">
        {{product.manufacturer}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="size">
      <mat-header-cell *matHeaderCellDef><span id="lbl-size">Size</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="size-{{i+1}}">
        {{product.labelSize}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="form">
      <mat-header-cell *matHeaderCellDef><span id="lbl-form">Form</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="form-{{i+1}}">
        {{product.form}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="lastPurchaseDate">
      <mat-header-cell *matHeaderCellDef><span id="lbl-purchase-date">Last Purchase Date</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="purchase-date-{{i+1}}">
        {{product.invoiceDateString}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="lastPurchasePrice">
      <mat-header-cell *matHeaderCellDef><span id="lbl-last-purchase-price">Last Purchase Price</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="last-purchase-price-{{i+1}}">
        {{product.invoicePrice | currency}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="currentPrice">
      <mat-header-cell *matHeaderCellDef><span id="lbl-price">Current Price</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="price-{{i+1}}">
        {{product.currentPrice | currency}}
        <span *ngIf="(product.invoicePrice/0.99).toFixed(2)>product.currentPrice && data=='price changes alert'"><span  class="down-arrow-table lbl-price"></span></span> 
       
      </mat-cell>
    
    </ng-container>
    <ng-container matColumnDef="caseQuantity" *ngIf="websiteName=='Major'">
      <mat-header-cell *matHeaderCellDef><span>Case Qty</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="cQty-{{i+1}}">
        {{product.packQuantity }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="caseQuantity" *ngIf="websiteName=='Parmed'">
      <mat-header-cell *matHeaderCellDef><span>Case Qty</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="cQty-{{i+1}}">
        {{product.caseQty}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef><span id="lbl-qty">Quantity</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="qty-{{i+1}}">
        <input type="text" name="Quantity" maxlength="{{qtyLength}}" (keyup) ="checkCaseQtyMultiplier(product)"
          [(ngModel)]="product.quantity" parNumberOnly
          [ngClass]="{'redBorder': product.isQtyMismatch}"
          [attr.disabled]="!product.packQuantity ? 'disabled' : null"> 
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="inCart" >
      <mat-header-cell *matHeaderCellDef ><span id="lbl-in-cart">In Cart</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" id="in-cart-{{i+1}}">
        {{product.onOrder}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="addToFav">
      <mat-header-cell *matHeaderCellDef> <span id="lbl-add-fav-list">Add To Favorites</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index" [ngClass]="{'mat-column-addToFav': websiteName === 'Major'}">
        <select class="no-mobile fav-list-drop-down" id="add-fav-list-{{i+1}}" placeholder="Add to Favorites" *ngIf="!product.excluded" name="selectedList"
          [(ngModel)]="product.favListSelected" (change)="onSelectList(product)"
          [attr.disabled]="!product.packQuantity ? 'disabled' : null">
          <option value="" id="add-fav-list-{{i+1}}-0" [disabled]="true">Add to Favorites</option>
          <option value="createNewList" id="add-fav-list-{{i+1}}-create-new">Create New List</option>
          <option *ngFor="let favList of favLists; let j = index" id="add-fav-list-{{i+1}}-{{j+1}}" [ngValue]="favList">
            {{ favList.name.replace(' ', '&nbsp;') }}
          </option>
        </select>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="watchlist">
      <mat-header-cell *matHeaderCellDef><span id="lbl-watchlist">Watchlist</span></mat-header-cell>
      <mat-cell *matCellDef="let product;let i = index">
        <mat-checkbox color="primary" *ngIf="!product.excluded" id="watchlist-{{i+1}}" 
        title="{{product.isWatchListItem ? 'Remove from Watchlist' : 'Add to Watchlist'}}" id="{{i+1}}-14"
          name="watchlist{{i}}" class="mat-form-field" [(ngModel)]="product.isWatchListItem"
          [disabled]="!product.packQuantity ? 'disabled' : null" (change)="onWatchlistToggle(product)"></mat-checkbox>
      </mat-cell>
    </ng-container>
    <mat-header-row class="rowHeaderColor" *matHeaderRowDef="displayedColumnsFun();"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumnsFun();let i = index;"></mat-row>
  </mat-table>
  </div>
  <div class="empty-grid" *ngIf="emptyGrid.showMessage">
    <span [innerHTML]="emptyGrid.message"></span>
  </div>
  <div class="add-cart-button bottom">
    <button type="submit" mat-raised-button id="btn-add-to-cart-bottom" color="accent" [disabled]="!isAddToCartDisable()">Add To Cart</button>
  </div>
</form>
<div class="products-legend no-mobile" >
  <h3 id="lbl-product-alert-legend">PRODUCT ALERT LEGEND</h3>
  <p>
    <span id="refrigerated-product-msg" class="cold">Refrigerated products ordered after 8 p.m. EST Thursday will ship
      the
      following Monday.</span>
  </p>
  <p>
    <span id="hazardous-product-msg" class="hazard">
      Hazardous products ship ground (3-5 days) separate from the rest of your
      order.
    </span>
  </p>
  <p *ngIf="websiteName == 'Parmed'">
    <span id="lowest-priced-msg" class="lowest">
      This is the lowest priced item for each GCN among the displayed
      products.
    </span>
  </p>
  <span *ngIf="data=='price changes alert'" style="margin-left: 5px;">Price Reduction<span class="down-arrow"
      style="float: left;margin: 5px !important;"></span></span>
</div>

<div class="pricechange-close" *ngIf="data=='price changes alert'">
  <button type="submit" mat-raised-button id="btn-add-to-cart-bottom" color="accent" (click)="onClose()" >Close</button>
</div> 

